<template>
  <div class="tabed-nav">
    <ul>
      <li @click="selectTab(0)">
        <span :class="{ active: isActive(0) }" class="inner"> Wall </span>
      </li>
      <li @click="selectTab(1)">
        <span :class="{ active: isActive(1) }" class="inner">
          Tower
        </span>
      </li>
      <li @click="selectTab(2)">
        <span :class="{ active: isActive(2) }" class="inner">
          Cabinet
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TabsComponent',
  props: {
    activateTab: Function,
    activeTab: Number
  },
  data() {
    return {
      selectedIndex: this.activeTab, // the index of the selected tab,
      tabs: [] // all of the tabs
    };
  },
  watch: {
    activeTab: function(val) {
      this.selectedIndex = val;
    }
  },
  mounted() {},
  methods: {
    isActive: function(index) {
      if (index === this.selectedIndex) return true;
      return false;
    },
    selectTab: function(index) {
      this.selectedIndex = index;
      this.activateTab(index);
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '~@eds/vanilla/variables/global.less';

.tabed-nav {
  margin: 0 0 0 @space-large;
  ul {
    list-style-type: none;
    display: flex;
    flex-direction: row;
    height: 100%;
    cursor: pointer;
    span {
      line-height: 1.5em;
    }
    li {
      padding: 0 @space-base 2px @space-base;
    }
    .active {
      border-bottom: 2px solid @table-selected;
      // padding: 0 @space-base;
      font-weight: bold;
    }
    span:hover {
      border-bottom: 2px solid @table-selected;
      // padding: 0 @space-base;
      font-weight: bold;
    }
  }
}
</style>
